/*jshint esversion: 9 */
import React, { Component } from "react";
import { connect } from "react-redux";

import * as actions from "../store/actions/index";
import Person from "./Person";
import { doLog } from "../shared/utility";

class Persons extends Component {
  state = {
    
  };

  addInitialPersonItem() {
    const personFields = null;
    const personItem = {
        personInstance: 0,
        personFields: personFields,
    };

    if (doLog()) console.log("[Persons] addInitialPersonItem personItem:", personItem);
    this.props.onAddToPersonArray(this.props.personArray, personItem);
    return personItem;
  }

  checkForEmptyArray() {
    if (
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIRENAMEINFO === "Y"
    ) {
      if (doLog()) console.log("[Persons].checkForEmptyArray RequireProperty:" + this.props.selectedIncidentTypeData.REQUIRENAMEINFO);
        const arraySize = this.props.personArray.length;
        if (doLog()) console.log("[Persons].checkForEmptyArray arraySize:" + arraySize);
        if (arraySize === 0) {
          this.addInitialPersonItem();
        }
    }
  }

  componentDidMount() {
    if (doLog()) console.log("[Persons].componentDidMount");
    this.checkForEmptyArray();
  }

  componentDidUpdate() {
    if (doLog()) console.log("[Persons].componentDidUpdate props:", this.props);
    this.checkForEmptyArray();
  }

  render() {
    if (doLog()) console.log("[Persons].render selectedIncidentTypeData:", this.props.selectedIncidentTypeData);
    const content = [];

    if (
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIRENAMEINFO === "Y"
    ) {
      if (doLog()) console.log("[Persons].render RequireName:", this.props.selectedIncidentTypeData.REQUIRENAMEINFO);
      const arraySize = this.props.personArray.length;
      if (doLog()) console.log("[Persons].render arraySize:" + arraySize);
      if (arraySize > 0) {
        for (let i = 0; i < arraySize; i++) {
          const item = this.props.personArray[i];
          content.push(<Person key={item.personInstance} item={item} />);
        }
      }
    }

    if (doLog()) console.log("[Persons].render content:", content);

    return (
    <div>
        {content}
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log('[Persons].mapStateToProps state:', state);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    configuration: state.trans.configuration,
    incidentTypeDataList: state.trans.incidentTypeDataList,
    //
    personArray: state.trans.personArray,
    personInvolvementList: state.trans.personInvolvementList,
    //
    stateList: state.trans.stateList,
    //
    selectedIncidentTypeData: state.trans.selectedIncidentTypeData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddToPersonArray: (personArray, personItem) =>
      dispatch(actions.addToPersonArray(personArray, personItem)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Persons);
